module.exports = __webpack_public_path__ + "static/media/responsive-silver-tier-person.ff0e9f6d.svg";